import React, { useState, useEffect } from 'react';
import { Check, X, Loader } from 'lucide-react';
import axios from 'axios';
import { useSearchParams } from "react-router-dom";

const PaymentStatusFedapayFalse = () => {
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [searchParams] = useSearchParams();

  const paymentId = searchParams.get("paymentId");
  const SECRET_KEY = "pvk_41z3r1|01J9BV23GNVNDKZSRSC5QC68R0";
  const TELEGRAM_LINK = "http://t.me/KappelavendeurBot/vendeur";

  const verifyPayment = async () => {
    setIsLoading(true);
  
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  
    try {
      // Ajout d'un délai de 5 secondes (5000 millisecondes)
      await delay(5000);
  
      // Ici tu peux placer l'appel API ou tout autre traitement après le délai
      // const response = await axios(config);
      setPaymentStatus('failure');
    } catch (error) {
      console.error('Erreur lors de la vérification:', error);
      setPaymentStatus('failure');
    } finally {
      setIsLoading(false);
    }
  };
  
  useEffect(() => {
    verifyPayment();
  }, []);
  

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 p-8">
      <div className="max-w-md mx-auto space-y-6">
        <div className="text-center mb-12">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">
            Statut du Paiement
          </h1>
          <div className="h-1 w-20 bg-blue-500 mx-auto rounded-full"></div>
        </div>

        {isLoading && (
          <div className="bg-white p-8 rounded-lg shadow-lg text-center">
            <div className="flex justify-center mb-4">
              <Loader className="w-8 h-8 text-blue-500 animate-spin" />
            </div>
            <p className="text-gray-600 font-medium">
              Vérification du paiement en cours...
            </p>
          </div>
        )}

        {!isLoading && paymentStatus === 'success' && (
          <div className="space-y-4">
            <div className="rounded-lg border border-green-200 bg-green-50 p-4 relative flex items-start gap-3">
              <div className="mt-1">
                <Check className="w-5 h-5 text-green-500" />
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-green-800 mb-1">
                  Paiement effectué avec succès
                </h3>
                <p className="text-green-700">
                  Cliquez sur le bouton ci-dessous pour accéder à votre contenu sur Telegram.
                </p>
              </div>
            </div>
            
              <a href={TELEGRAM_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full block text-center bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
            >
              Accéder au contenu sur Telegram
            </a>
          </div>
        )}

        {!isLoading && paymentStatus === 'failure' && (
          <div className="space-y-4">
            <div className="rounded-lg border border-red-200 bg-red-50 p-4 relative flex items-start gap-3">
              <div className="mt-1">
                <X className="w-5 h-5 text-red-500" />
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-red-800 mb-1">
                  Paiement non effectué
                </h3>
                <p className="text-red-700">
                  Une erreur est survenue lors du traitement de votre paiement.
                </p>
              </div>
            </div>
            <button
              onClick={verifyPayment}
              className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold py-3 px-6 rounded-lg transition-colors"
            >
              Vérifier à nouveau
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentStatusFedapayFalse;